import actionTypes from './actionTypes';

export const initialState = {
  featuredArticle: null,
  articles: [],
  haveMoreArticles: true,
  relatedCommunities: [],
};

export default function (state = initialState, action) {
  switch(action.type) {
    case actionTypes.FETCH_ARTICLE_LIST_SUCCESS:
      return {
        ...state,
        featuredArticle: action.articles.featuredArticle,
        articles: [...state.articles, ...action.articles.articles],
        haveMoreArticles: action.haveMoreArticles,
      };

    case actionTypes.FETCH_ARTICLE_LIST_RELATED_COMMUNITIES_SUCCESS: {
      return {
        ...state,
        relatedCommunities: action.relatedCommunities || [],
      };
    }
    case actionTypes.FETCH_ARTICLE_LIST_RELATED_TAGS_SUCCESS:
      return {
        ...state,
        relatedTags: action.relatedTags,
      };
  }

  return state;
}



// WEBPACK FOOTER //
// ./src/modules/articles/articleList/reducer.js